import { Button } from "@/ui/button";
import clsx from "clsx";
import {
  GradientStyles,
  BackgroundStyles,
  ActiveStyles,
  HoverStyles,
} from "@/ui/gradient-border-radius";

const ConfirmButton = ({
  enabled = false,
  onClick = () => {},
  loading,
  success,
  className,
  gradient,
  background,
  activeStyle,
  hover,
}: {
  enabled?: boolean;
  onClick: () => void;
  loading?: boolean;
  success?: boolean;
  className?: string;
  gradient?: keyof typeof GradientStyles;
  background?: keyof typeof BackgroundStyles;
  activeStyle?: keyof typeof ActiveStyles;
  hover?: keyof typeof HoverStyles;
}) => {
  return (
    <>
      <div className="flex items-center">
        <Button
          enabled={enabled}
          title="Confirm"
          className={clsx("text-xs w-[9.375rem] h-[1.875rem]", className)}
          onClick={onClick}
          loading={loading}
          success={success}
          gradient={gradient}
          background={background}
          activeStyle={activeStyle}
          hoverStyle={hover}
        />
      </div>
    </>
  );
};

export default ConfirmButton;
